import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "disabled", "tabIndex", "label"];
import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
export var Checkbox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var checked = props.checked,
      disabled = props.disabled,
      tabIndex = props.tabIndex,
      label = props.label,
      restProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", _extends({}, restProps, {
    ref: ref,
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    className: styles.input,
    tabIndex: tabIndex
  })), /*#__PURE__*/React.createElement("span", {
    className: cn(props.className, styles.checkbox, styles.common, props.checked && styles.checked, props.disabled && styles.disabled)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.box
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "10",
    viewBox: "0 0 12 10"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.983 9.193l.97.807.824-.963L12 1.773 10.048 0 4.562 6.403 1.636 3.794 0 5.878z"
  })))), /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, props.label)));
});
Checkbox.displayName = 'Checkbox';